import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import LoadingScreen from '@panel/avisos/src/components/LoadingScreen/LoadingScreen';
import { toMessage } from '@panel/leads/src/services/utils/routes';

import { myAccount, myActivity, myCompany, userData } from '@panel/usuarios/src/services/utils/routes';

import { Header } from './sections';
import botmaker from './state/botmaker';
import { useFavicon } from './components/hooks';
import { useGetUser, useHideHeader, useAppliedClassName, useLogin, useBumexFeatures } from './hooks';
import { useBanner } from './hooks/useBanner';

import './core/global-styles.scss';

const Loader = <LoadingScreen />;

const LazyLanding = React.lazy(() => import('./sections/landingPublicador'));

const LazyBum = React.lazy(() => import('@panel/publicador/src/utils/RedirectBum'));
const LazyAvisos = React.lazy(() => import('@panel/avisos'));
const LazyPublicador = React.lazy(() => import('@panel/publicador'));
const LazyPublicadorProfesionales = React.lazy(() => import('@panel/publicador-profesionales'));
/* PUER */
const LazyUser = React.lazy(() => import('@panel/usuarios/src/pages/myAccount')); // URL: /panel/configuracion/
const LazyUserData = React.lazy(() => import('./sections/configuration')); // URL: /panel/configuracion/datos
const LazyCompany = React.lazy(() => import('@panel/usuarios/src/pages/MyCompany')); // URL: /panel/empresa/
const LazyActividad = React.lazy(() => import('./sections/activity/index')); // URL: /panel/actividad/

const NotFound = React.lazy(() => import('./sections/notFound/notFound'));
const PermissionsError = React.lazy(() => import('./sections/permissionsError'));
const LazyDesempeno = React.lazy(() => import('@panel/desempeno'));
const LazyEstadisticas = React.lazy(() => import('@panel/estadisticas'));
const LazyLandingZonaDemand = React.lazy(() => import('@panel/landing-zona-demand'));
const LazyCompartirDesempeno = React.lazy(() => import('@panel/compartir-desempeno'));
const LazyContactosPermisos = React.lazy(() => import('@panel/contactos-permisos'));
const LazyOnboardingFull = React.lazy(() => import('@panel/commons/services/OnboardingFull/src/components/app'));

const LazyLeadsContactos = React.lazy(() => import('@panel/leads/src/pages/contactos'));
const LazyLeadsContacto = React.lazy(() => import('@panel/leads/src/pages/contacto'));
const LazySeekerMessage = React.lazy(() => import('@panel/leads/src/pages/seekerMessage'));

const LazyFeedbackQuestions = React.lazy(() => import('@panel/feedback/src/pages/feedbackQuestions'));
const LazyFeedbackResponse = React.lazy(() => import('@panel/feedback/src/pages/feedbackResponse'));

function App({ history }) {
  botmaker(history);
  useFavicon();
  useGetUser();
  const { showBanner, BannerUnifiedPublisher } = useBanner();
  useHideHeader();
  useAppliedClassName();
  useLogin();
  useBumexFeatures();
  return (
    <>
      <Header />
      {showBanner && <BannerUnifiedPublisher />}
      <React.Suspense fallback={Loader}>
        <Switch>
          <Route path='/' exact>
            <Redirect to='/avisos' />
          </Route>
          <Route path='/bum'>
            <LazyBum />
          </Route>
          <Route path='/landing/publicadorUnificado' exact>
            <LazyLanding />
          </Route>
          <Route path='/avisos'>
            <LazyAvisos />
          </Route>
          <Route path='/publicador' strict={false}>
            <LazyPublicador />
          </Route>
          <Route path='/publicador-profesionales' strict={false}>
            <LazyPublicadorProfesionales />
          </Route>
          <Route path='/desempeno'>
            <LazyDesempeno />
          </Route>
          {/* PUER */}
          <Route exact path={userData}>
            <LazyUserData />
          </Route>
          <Route path={myCompany}>
            <LazyCompany />
          </Route>
          <Route path={myAccount}>
            <LazyUser />
          </Route>
          <Route path={myActivity}>
            <LazyActividad />
          </Route>

          <Route exact path='/interesados'>
            <LazyLeadsContactos />
          </Route>
          <Route path='/interesados/:contactId'>
            <LazyLeadsContacto />
          </Route>
          <Route path={toMessage}>
            <LazySeekerMessage />
          </Route>
          <Route path='/feedback/:id' exact>
            <LazyFeedbackQuestions />
          </Route>
          <Route path='/feedback/:id/response' exact>
            <LazyFeedbackResponse />
          </Route>
          <Route path='/estadisticas'>
            <LazyEstadisticas />
          </Route>
          <Route path='/zona-demand'>
            <LazyLandingZonaDemand />
          </Route>
          <Route path='/compartir-desempeno'>
            <LazyCompartirDesempeno />
          </Route>
          <Route path='/contactos-permisos'>
            <LazyContactosPermisos />
          </Route>
          <Route path='/servicios/full'>
            <LazyOnboardingFull />
          </Route>
          <Route path='/permissionserror'>
            <PermissionsError />
          </Route>
          <Route path='/*'>
            <NotFound />
          </Route>
        </Switch>
      </React.Suspense>
    </>
  );
}

export default App;
